var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quad__block__child big__text"},[(_vm.title)?_c('h4',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.text)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_vm._v(" "),(_vm.link)?_c('a',{attrs:{"href":_vm.link},domProps:{"innerHTML":_vm._s(_vm.link_label)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib?{}!./scripts/vue/BigText.vue?vue&type=template&id=3119e0ca&scoped=true&
// module id = 240
// module chunks = 0